import { observer } from 'mobx-react';
import { Box, Typography } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { downloadLicenseDocument } from './licensesTab';

// observer: reacts to verificationStore.uploadedTrackRecordFile set async after upload.
export const UploadedTrackRecordFile = observer(({
  classes,
  verificationStore,
  documentStore,
}: {
  classes: Record<string, string>;
  verificationStore?: any;
  documentStore?: any;
}) => {
  const file = verificationStore?.uploadedTrackRecordFile;
  if (!file) return null;

  return (
    <Box style={{ marginTop: 16 }}>
      <Typography variant="subtitle1" style={{ fontWeight: 700, marginBottom: 8 }}>
        Uploaded Track Record
      </Typography>
      <Box
        className={classes.uploadLink}
        style={{ display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}
        onClick={() =>
          downloadLicenseDocument(
            documentStore,
            verificationStore,
            { original_file_name: file.originalFileName },
            file.taskId,
          )
        }
      >
        <GetAppIcon style={{ fontSize: 16 }} />
        <Typography style={{ color: 'inherit', fontSize: 14 }} noWrap>
          {file.originalFileName}
        </Typography>
      </Box>
    </Box>
  );
});
